
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import {
  requiredRule,
  minNumberRule,
  maxNumberRule,
} from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Create",

  data: () => ({
    model: {} as any,
    specialities: [] as any,
    errorMessages: {} as any,
  }),

  computed: {
    computedRules(): object {
      return {
        minNum: minNumberRule.bind(this),
        maxNum: maxNumberRule.bind(this),
        required: requiredRule.bind(this),
      };
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const response = await API.specialities().getList();

      next((vm) => {
        vm.specialities = response;
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    getYearsInterval() {
      const allowedYears: number[] = [];
      for (
        let i = new Date().getFullYear();
        i <= new Date().getFullYear() + 5;
        i++
      ) {
        allowedYears.push(i);
      }
      return allowedYears;
    },
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          await this.$API.budgetPlaces().create(this.model);
          await this.$router.push("/budgetPlaces");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global-alert.successful_create")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
